/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../actions/actions';
import theme from '../../theme';


const LogoutPage = (props) => {
	const navigate = useNavigate();

	useEffect(() => {
		props.logout();
		navigate('/login');
	});

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<div
					style={{
						width: '100vw',
						height: '100vh',
						backgroundSize: '100% 100%',
						backgroundImage: 'url(images/mainbg.jpg)'
					}}
				>
					<LinearProgress />
				</div>
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

LogoutPage.propTypes = {
	logout: PropTypes.func.isRequired
};

const mapDispatchToProps = {
	logout
};

export default connect(null, mapDispatchToProps)(LogoutPage);
